import ElectricalConditionReportForm from './ElectricalConditionReportForm';
import ElectricalConditionReportPDF from './ElectricalConditionReportPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';

export default {
  Form: ElectricalConditionReportForm,
  PDF: ElectricalConditionReportPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF
};